/* Publish by EComposer at 2026-10-14 03:10:32*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ycqo7xq8hx"]=  window.__ectimmers["ecom-ycqo7xq8hx"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-ycqo7xq8hx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ycqo7xq8hx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hinb88e2jgr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hinb88e2jgr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wder49zcsid').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wder49zcsid', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k4zprxk0ny').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k4zprxk0ny', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rjzvvkfo6f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rjzvvkfo6f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hk2axoc8him').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hk2axoc8him', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n8xt8arpsup').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n8xt8arpsup', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e8p2mjt1jx6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e8p2mjt1jx6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-odqpscdwk6h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-odqpscdwk6h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-en7ph60snzq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-en7ph60snzq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xx34m94x9nc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xx34m94x9nc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4532fx0xd8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4532fx0xd8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5xj85wlr02g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5xj85wlr02g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hl5lxxdwoy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hl5lxxdwoy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gc62lv261f5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gc62lv261f5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ic3cromx3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ic3cromx3o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h9hqhqbkaoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h9hqhqbkaoj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-llijlz00ozs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-llijlz00ozs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rmrou580dx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rmrou580dx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3lww4biia5b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3lww4biia5b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6acwmvjej8e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6acwmvjej8e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u00uadj3ynj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u00uadj3ynj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ro44ydwvpq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ro44ydwvpq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m3y5r4bp97j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m3y5r4bp97j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-frh9gb8hb2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-frh9gb8hb2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qd8vy1tkzhi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qd8vy1tkzhi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kjq6xizv4lc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kjq6xizv4lc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ccocc3jrqz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ccocc3jrqz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s51ydrdjczm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s51ydrdjczm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gn3lvpuaj2u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gn3lvpuaj2u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-brzb7h7xdrv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-brzb7h7xdrv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h00nuzdc5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h00nuzdc5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1pnqlxz0z4cj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1pnqlxz0z4cj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5d0bz55nkns').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5d0bz55nkns', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rxn6imwf6q9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rxn6imwf6q9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8j6ipc3iep').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8j6ipc3iep', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1wc67gevea9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1wc67gevea9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nq7memfsd4d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nq7memfsd4d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kmb79hugxx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kmb79hugxx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y356ux6hbg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y356ux6hbg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mmzt7b0jkdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mmzt7b0jkdh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fz6xoq40pkq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fz6xoq40pkq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d94o65pjzht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d94o65pjzht', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vik8pvsezbg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vik8pvsezbg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b8feee87vy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b8feee87vy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ulogifcqksk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ulogifcqksk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4gzew33gri4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4gzew33gri4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v6uvcz4afwo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v6uvcz4afwo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y22nlccywia').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y22nlccywia', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wza0mqzhy3n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wza0mqzhy3n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5r29g24mlwe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5r29g24mlwe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1mzjtcsxoex').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1mzjtcsxoex', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0hqki24ppolm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0hqki24ppolm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pfubqkag73q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pfubqkag73q', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-orwkmz54ju').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-orwkmz54ju', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fhxphbakjzm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fhxphbakjzm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4i0o9qntc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4i0o9qntc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99a85r4rmoc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99a85r4rmoc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-832a9sezt59').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-832a9sezt59', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzxjcn1np37').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzxjcn1np37', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zrvcv5suif').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zrvcv5suif', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lls5r1ek9r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lls5r1ek9r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h94k3bk810h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h94k3bk810h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vmykwczvch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vmykwczvch', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-koj91df3iqf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-koj91df3iqf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6tp3krhmqi7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6tp3krhmqi7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xq45i8sr1le').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xq45i8sr1le', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lf9vcebk4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lf9vcebk4j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rw64xlpkw3o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rw64xlpkw3o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k7y78cmmyz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k7y78cmmyz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvo597fdx2d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvo597fdx2d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0yx9ol8nm1e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0yx9ol8nm1e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1vaoo4b6to8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1vaoo4b6to8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-64pd23k5vb5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-64pd23k5vb5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vfh8c3byuir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vfh8c3byuir', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bj4rki7q2km').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bj4rki7q2km', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fzi569x830o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fzi569x830o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-83x3n20qqpo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-83x3n20qqpo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dz0nw65jmo6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dz0nw65jmo6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ts7ih3kvsc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ts7ih3kvsc', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-j5ffsl1dlc"]=  window.__ectimmers["ecom-j5ffsl1dlc"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),s=this.settings.action;function o(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var p;(p=d.ec_splide)==null||p.refresh()})},50),r())}e.forEach((a,l)=>{s==="click"||window.screen.width<1025?a.onclick=()=>o(a,l):a.onmouseover=()=>o(a,l)});function n(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let m=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,m)}}}setTimeout(()=>{n()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",n,!1)

                    });
                    
                        document.querySelectorAll('.ecom-j5ffsl1dlc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j5ffsl1dlc', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-q9wcchosr4"]=  window.__ectimmers["ecom-q9wcchosr4"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-q9wcchosr4"]["kvgyzr28z"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-q9wcchosr4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q9wcchosr4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4zi0mr660gp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4zi0mr660gp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m493uvjy9c8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m493uvjy9c8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9excgo865tq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9excgo865tq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fvbe99kc9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fvbe99kc9k', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lso80elr33h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lso80elr33h', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-onwyo9fjknd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-onwyo9fjknd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zwcygrt50f8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zwcygrt50f8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-44iizrzg8v8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-44iizrzg8v8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xm4ijrmx6ln').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xm4ijrmx6ln', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0hr31we6z8j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0hr31we6z8j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fqbxhifq26').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fqbxhifq26', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-musfts6yv2b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-musfts6yv2b', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i585hl2mwcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i585hl2mwcr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cu0k9sod579').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cu0k9sod579', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ii7c56tum7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ii7c56tum7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sbfgoovljxf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sbfgoovljxf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lvc2wh3rv2l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lvc2wh3rv2l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j08eagzgpyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j08eagzgpyh', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cyjewa7ovt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cyjewa7ovt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzphp5y3cko').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzphp5y3cko', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-34kuiffx6mj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-34kuiffx6mj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l7soj39cfbl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l7soj39cfbl', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6qnz0d0h5q7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6qnz0d0h5q7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b93m2o0d42l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b93m2o0d42l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mmyiviu6nje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mmyiviu6nje', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eskgrcnp5ho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eskgrcnp5ho', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gmotmr1pbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gmotmr1pbj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9jx5e8xlumf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9jx5e8xlumf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gjew4qw9lg5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gjew4qw9lg5', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6974viov6qd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6974viov6qd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8iuahv9qava').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8iuahv9qava', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2l5u9xgxd37').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2l5u9xgxd37', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2xdd15vhvt7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2xdd15vhvt7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bnsi3h6lwfb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bnsi3h6lwfb', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w3r9aglafq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w3r9aglafq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pqobbxbxdt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pqobbxbxdt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vd0l5xbbpch').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vd0l5xbbpch', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jeih8h134me').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jeih8h134me', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8tc9myobmw8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8tc9myobmw8', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iazu3whx4g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iazu3whx4g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-is25xfhljoo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-is25xfhljoo', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vvd1ukd98in').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vvd1ukd98in', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h8okhog5z8t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h8okhog5z8t', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nrojgpsxkda').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nrojgpsxkda', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ooxdreppwj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ooxdreppwj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4if7fmos6sr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4if7fmos6sr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mean4s29pnf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mean4s29pnf', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pdqrxpwcb5l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pdqrxpwcb5l', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2j0whvaggjn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2j0whvaggjn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ar6qk7ozcr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ar6qk7ozcr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fvhtbv3l5mm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fvhtbv3l5mm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7d3xoxp3wlv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7d3xoxp3wlv', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-imgv9bhmxlq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-imgv9bhmxlq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-52bteqw058t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52bteqw058t', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zv6yiztruie').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zv6yiztruie', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n6s31x74vt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n6s31x74vt', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ber433debsc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ber433debsc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-50vjidts6dj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-50vjidts6dj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u43q1cyu0j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u43q1cyu0j', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tsczm6cwjoj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tsczm6cwjoj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d175giel0fm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d175giel0fm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kcxdfmza1f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kcxdfmza1f', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hesdnyh76ir').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hesdnyh76ir', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aup19994k3c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aup19994k3c', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mted2zz46lr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mted2zz46lr', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23l7s8umyv7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23l7s8umyv7', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-75widzfscsg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-75widzfscsg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-no0zhdtfdjq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-no0zhdtfdjq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gaesv8kcq5a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gaesv8kcq5a', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8ns2wmncyot').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8ns2wmncyot', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-70pyuozqqj3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-70pyuozqqj3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b2iqqif9zbs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b2iqqif9zbs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hy0cmkxjbdj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hy0cmkxjbdj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2rzwaqoai8r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2rzwaqoai8r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ae5twuqu3xs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ae5twuqu3xs', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pp8lglj61uj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pp8lglj61uj', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jwdg1j16u6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jwdg1j16u6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rf45ogjo7pd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rf45ogjo7pd', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-exryzj3cmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-exryzj3cmp', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-stgvvzjt6te').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-stgvvzjt6te', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dnx75y7qzmw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dnx75y7qzmw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jnig6bfx8lc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jnig6bfx8lc', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8rs434y10ey').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8rs434y10ey', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bjdeyztbfop').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bjdeyztbfop', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aul588gt6zw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aul588gt6zw', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bsy9f4cjxl4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bsy9f4cjxl4', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gu689zrmv7r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gu689zrmv7r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vwauheeam28').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vwauheeam28', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vectgyhpxxk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vectgyhpxxk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}